import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import RemoteLayout from "./layout";
import { Button } from "../../components/workshop";

const EndCall = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <RemoteLayout>
      <div className="flex flex-col items-center justify-center text-white-100 text-center min-h-[60vh]">
        <div className="mb-8">
          <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-rose-500/20 flex items-center justify-center">
            <svg
              className="w-12 h-12 text-rose-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M16 8l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2M7 8H5a2 2 0 00-2 2v10a2 2 0 002 2h14a2 2 0 002-2V10a2 2 0 00-2-2h-2M7 8V6a2 2 0 012-2h6a2 2 0 012 2v2"
              />
            </svg>
          </div>
          <h1 className="text-3xl md:text-4xl font-bold text-white-100 mb-4">
            {t("endCall.heading") || "Call Ended"}
          </h1>
          <p className="text-lg md:text-xl text-white-100/80 max-w-xl mx-auto mb-2">
            {t("endCall.message") ||
              "You have been removed from the workshop. Thank you for participating."}
          </p>
          <p className="text-base text-white-100/60 max-w-xl mx-auto">
            {t("endCall.subMessage") ||
              "If you believe this was a mistake, please contact the workshop moderator."}
          </p>
        </div>
        <div className="mt-8">
          <Button
            text={t("endCall.backToLogin") || "Back to Login"}
            onClick={() => navigate("/online")}
            type="rounded"
            className="!bg-orange-default hover:!bg-orange-100"
          />
        </div>
      </div>
    </RemoteLayout>
  );
};

export default EndCall;
